"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoPanel = void 0;
var react_1 = __importDefault(require("react"));
var NoPanel = function (props) {
    return react_1.default.createElement(react_1.default.Fragment, null, props.children);
};
exports.NoPanel = NoPanel;
//# sourceMappingURL=NoPanel.js.map